/**
 * Org-specific party role labels (athlete, coach, parent/guardian).
 * Backed by organization.role_labels from PartyRoles.
 */

import { useCallback, useMemo } from "react";
import { useAppContext } from "../context/AppContext";
import type { RoleLabelsByKey } from "../object-actions/types/types";
import { getRoleDisplayLabel } from "../utils/roleLabels";

export function usePartyRoles() {
  const { organization } = useAppContext();
  const labels = organization?.role_labels ?? null;

  const getPartyRoleLabel = useCallback(
    (roleKey: keyof RoleLabelsByKey, options?: { plural?: boolean }) =>
      getRoleDisplayLabel(labels, roleKey, options),
    [labels]
  );

  return useMemo(
    () => ({
      labels,
      getPartyRoleLabel,
    }),
    [labels, getPartyRoleLabel]
  );
}
